import styled from 'styled-components';

type AlignContentProps = {
  to: 'center' | 'left' | 'right'
  expand?: boolean
}

export const AlignContent = styled.div<AlignContentProps>`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;

  align-items: ${props => {
    if (props.to === 'center') {
      return 'center';
    } else if (props.to === 'right') {
      return 'flex-end';
    }
    return 'flex-start';
  }};

  flex-grow: ${props => props.expand ? 1 : 0};
  height: ${props => props.expand ? '100%' : 'auto'};
  width: ${props => props.expand ? '100%' : 'auto'};
`;

AlignContent.defaultProps = {
  to: 'center',
  expand: false
};
